import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=5ea21be9&scoped=true&"
import script from "./mainPage.vue?vue&type=script&lang=ts&"
export * from "./mainPage.vue?vue&type=script&lang=ts&"
import style0 from "./mainPage.vue?vue&type=style&index=0&id=5ea21be9&scoped=true&lang=scss&"
import style1 from "./mainPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea21be9",
  null
  
)

export default component.exports